/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import AppRouterDefinition from "./AppRouterDefinition";
import { adressenRouterDefintions } from "./Cloud/Adressen/Routes/adressenRouterDefintions";
import { auswertungenRouterDefintions } from "./Cloud/Auswertungen/Routes/auswertungenRouterDefintions";
import { belegeRouterDefintions } from "./Cloud/Belege/Routes/belegeRouterDefintions";
import { buchungsportalRouterDefinitions } from "./Cloud/Buchungsportal/Routes/buchungsportalRouterDefinitions";
import { dokumenteRouterDefinitons } from "./Cloud/Dokumente/Routes/dokumenteRouterDefinitons";
import { einstellungenRouterDefintions } from "./Cloud/Einstellungen/Routes/einstellungenRouterDefintions";
import SchnelleinstiegView from "./Cloud/Einstellungen/Views/SchnelleinstiegView";
import { exporteRouterDefintions } from "./Cloud/Exporte/Routes/exporteRouterDefintions";
import { importeRouterDefinitions } from "./Cloud/Importe/Routes/importeRouterDefinitions";
import { mahlzeitenRouterDefintions } from "./Cloud/Mahlzeiten/Routes/mahlzeitenRouterDefintions";
import { reportsRouterDefinitions } from "./Cloud/Reports/Routes/reportsRouterDefinitions";
import { ressourcenRouterDefintions } from "./Cloud/Ressourcen/Routes/ressourcenRouterDefintions";
import { seminareRouterDefintions } from "./Cloud/Seminare/Routes/seminareRouterDefintions";
import { teilnahmenRouterDefintions } from "./Cloud/Teilnahmen/Routes/teilnahmenRouterDefintions";
import { eMailsRouterDefintions } from "./Management/EMails/Routes/eMailsRouterDefintions";
import { mandantenRouterDefintions } from "./Management/Mandanten/Routes/mandantenRouterDefintions";
import LogoutRedirect from "./Management/Mandanten/Views/LogoutRedirect";
import StartseiteView from "./Management/Mandanten/Views/StartseiteView";

export const appRouterDefinitions: Array<AppRouterDefinition> = [
    {
        path: "/",
        render: () => {
            return (
                <SchnelleinstiegView>
                    <StartseiteView />
                </SchnelleinstiegView>
            );
        },
        createBreadcrumbs: () => [],
        exact: true,
    },
    {
        path: "/logout",
        render: (renderProps: any) => <LogoutRedirect {...renderProps} />,
        createBreadcrumbs: () => [],
        exact: true,
        unauthorized: true,
    },
    ...auswertungenRouterDefintions,
    ...belegeRouterDefintions,
    ...dokumenteRouterDefinitons,
    ...reportsRouterDefinitions,
    ...seminareRouterDefintions,
    ...teilnahmenRouterDefintions,
    ...exporteRouterDefintions,
    ...importeRouterDefinitions,
    ...mandantenRouterDefintions,
    ...buchungsportalRouterDefinitions,
    ...einstellungenRouterDefintions,
    ...adressenRouterDefintions,
    ...ressourcenRouterDefintions,
    ...eMailsRouterDefintions,
    ...mahlzeitenRouterDefintions,
];
